'use client'

import { visibleSwatches, type ColorSwatch } from '@/lib/commerce/variantOptions'
import { cn } from '@/lib/utils'

export default function ColorSwatches({ colors, active, onSelect, tone = 'light', max = 6, className }: { colors: ColorSwatch[], active: string | null, onSelect: (_value: string) => void, tone?: 'light' | 'dark', max?: number, className?: string }) {
  if (colors.length === 0) return null
  const dark = tone === 'dark'
  const shown = visibleSwatches(colors, active, max)

  return (
    <div className={cn('flex flex-wrap items-center gap-0.5', className)}>
      {shown.map(({ value, hex, soldOut }) => {
        const isActive = value === active
        const label = soldOut ? `${value} — дууссан` : value
        return (
          <button key={value} type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); onSelect(value) }} aria-label={label} aria-pressed={isActive} title={label} className={cn('relative size-6 rounded-full p-0.5 border transition-colors cursor-pointer', isActive ? (dark ? 'border-white' : 'border-foreground') : 'border-transparent')}>
            <span className={cn('block size-full rounded-full border', dark ? 'border-white/25' : 'border-black/15', soldOut && 'opacity-40')} style={{ backgroundColor: hex }} />
            {soldOut && <span className={cn('absolute left-1/2 top-1/2 h-px w-4 -translate-x-1/2 -translate-y-1/2 -rotate-45', dark ? 'bg-white/80' : 'bg-foreground/60')} />}
          </button>
        )
      })}
      {colors.length > shown.length && <span className={cn('ml-1 text-[11px] tabular-nums', dark ? 'text-white/55' : 'text-muted-foreground')}>+{colors.length - shown.length}</span>}
    </div>
  )
}
